// Breath Grid — a 24px dot lattice in faint Amplifx blue behind the chat
// column, with a frosted-glass veil. A soft circular region of deeper dots
// roams on a 34s clock. Purely decorative: pointer-events:none + aria-hidden.
// Meant to be the first child of the chat viewport (position:relative), fixed
// to that viewport — it does NOT scroll with the messages.
import './BreathGrid.css';

export function BreathGrid() {
  return (
    <div className="vella-chat-bg" aria-hidden="true">
      <div className="dots-base" />
      <div className="dots-deep" />
      <div className="veil" />
    </div>
  );
}

export default BreathGrid;
